angular
  .module("formRecoveryPasswordArf.components", ["app.services"])
  .component("formRecoveryPasswordArf", {
    templateUrl: "ng/components/formRecoveryPasswordArf/formRecoveryPasswordArf.html",
    bindings: {
      identifier: "=",
      appConfig: "=",
      mode: "<",
      portal: "="
    },
    controllerAs: "formRecoveryPasswordArfCtrl",
    controller: function (
      $rootScope,
      $scope,
      validationService,
      $timeout,
      $userService,
      $configService,
      $portalService,
      $uniService,
      $typeDomainService,
      $arcService,
      $giuridicVersion,
      $privacyService,
      Fatturazione,
      $download,
      RichiestePostVendita,
      $transactionFactory,
      $location,
      $modalService,
      $RichiestePostVenditaService
    ) {
      var self = this;

      self.dealerUser = {};

      /**
       * Modalità di invio documentazione perdiodica
       */
      self.modalitaSelezionata = {};
      self.locked = true;


      self.modalitaDiInvio = [{}];

      self.selectNewModalita = function () {
        self.loadingSelectModalita = true;
        $userService
          .selectNewModalita(self.modalitaSelezionata)
          .then(function (response) {
            console.log("Esito: ", response);
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(function () {
            self.loadingSelectModalita = false;
          });
      };

      /**
       * end documentazione periodica
       */

      self.confirmedPassword = {};
      $scope.fr = {};
      self.context = $rootScope.context;
      self.isAru = $portalService.isAru();
      self.isArf = $portalService.isArf();

      self.$userService = $userService;
      self.$configService = $configService;
      /** Validation Object **/
      self.validations = {};
      self.validationService = validationService;

      $scope.pwChangeSuccess = 2;
      $scope.isConv = false;

      self.status = $configService.getUserStatus();
      self.type = $configService.getUser().type;
      self.firstAccess = $configService.getUser().firstAccess;
      self.transactionOtp =
        $configService.getUser().responseSendOtp &&
        $configService.getUser().responseSendOtp.context &&
        $configService.getUser().responseSendOtp.context.transactionId;

      self.transactionOtpMail =
        $configService.getUser().responseSendOtp &&
        $configService.getUser().responseSendOtp.context &&
        $configService.getUser().responseSendOtp.context.otpPecTransactionId;
      self.propMap = $rootScope.propMap;
      $scope.editBool = {
        tel: false,
        email: false,
        dealerUserEmail: false,
        refPersonName: false,
        refPersonType: false,
        refPersonTel: false,
        refPersonEmail: false,
      };

      if ($configService.getUser() && $configService.getUser().firstAccess) {
        $timeout(function () {
          $modalService.openModal('certificaCell-modal')
        }, 2000)
      }

      $scope.appUser = {
        tel: null,
        email: null,
        metadataAppUserPojo: {
          tipologiaContatto: null,
          personaRiferimentoPrincipale: null,
          fatturazioneElettronica: null,
        },
      };

      $scope.privacy = {};

      $scope.controlPrivacy = {
        cf: null,
        piva: null,
      };

      $scope.fr = $configService.getAppConfig();
      $scope.contact = $configService.getAppConfig();
      $scope.enableMenu = function () {
        $rootScope.isMenuDisabled = false;
      };

      $scope.clickCloseRecoveryPassword =
        $scope.$parent.clickCloseRecoveryPassword;

      self.recoveryNewPassword = function () {
        self.restCalled = true;
        /** Valid form first, if it is invalid overlayAlert and return **/
        /** required check **/
        //in recupero
        /*         if (!self.isRequiredOk()) {
          $rootScope.$broadcast("addAlert", {
            text: "CHANGEPASS_003",
          });
          return;
        } */
        /** validity check **/
        /*         if (!self.isValidationOk()) {
          $rootScope.$broadcast("addAlert", {
            text: "CHANGEPASS_004",
          });
          return;
        } */
        /* check if recovery pass in formally valid */
        if ($configService.getUser().type != propMap['USER_TYPE_VENDOR_NA'] && ((!!!self.appPasswordUser.recovery || (!!self.appPasswordUser.recovery && !validationService.passwordRegex.test(self.appPasswordUser.recovery))) && self.firstAccess)) {
          $rootScope.$broadcast("addAlert", {
            text: "CHANGEPASS_013",
          });
          self.restCalled = false;
          return;
        }
        if ($configService.getUser().type != propMap['USER_TYPE_VENDOR_NA'] && ((!!!self.appPasswordUser.recovery || (!!self.appPasswordUser.recovery && !validationService.passwordRegex.test(self.appPasswordUser.recovery))) && !self.firstAccess)) {
          $rootScope.$broadcast("addAlert", {
            text: "CHANGEPASS_014",
          });
          self.restCalled = false;
          return;
        }
        /* check if password is formally valid */
        if (!validationService.passwordRegex.test(self.appPasswordUser.password)) {
          $rootScope.$broadcast("addAlert", {
            text: "CHANGEPASS_012",
          });
          self.restCalled = false;
          return;
        }

        /** check if confirm password and password is equal**/
        if (
          self.appPasswordUser.password !=
          self.appPasswordUser.confirmedPassword
        ) {
          $rootScope.$broadcast("addAlert", {
            text: "CHANGEPASS_008",
          });
          self.restCalled = false;
          return;
        }

        self.isCustomer = function () {
          if (
            $configService.getUserType() ==
            $configService.getProperty("USER_TYPE_CUSTOMER")
          ) {
            return true;
          }
          return false;
        };

        /** Logic **/
        if (
          self.appPasswordUser.password ==
          self.appPasswordUser.confirmedPassword
        ) {
          //				self.appPasswordUser.identifier = self.identifier;

          if (
            $configService.getUserStatus() ==
            propMap["USER_STATUS_RECOVERYPASSWORD"]
          ) {
            self.appPasswordUser.identifier = $configService.getUser().identifier;
            var channel = $portalService
              .resolveContextApplicationName(context)
              .split("_")[1];
            if ($portalService.isAru()) {
              if (self.type == 'SIGNER' || self.type == 'PROVISIONAL') {
                $userService
                  .restorePassword(self.appPasswordUser)
                  .then(function (resp) {
                    if (resp.success) {
                      $rootScope.$broadcast("addAlert", {
                        text: "CHANGEPASS_005",
                      });
                      self.restCalled = false;

                      $rootScope.isMenuDisabled = false;
                      $scope.clickCloseRecoveryPassword();
                      location.reload();
                    } else {
                      $rootScope.$broadcast('cancel-timer');
                    }
                    self.restCalled = false;
                  })
                  .catch(function (error) {
                    $rootScope.$broadcast('cancel-timer');
                    console.log("error");
                    self.restCalled = false;
                  });

              } else {
                if (!!!self.otpMail || (!!self.otpMail && !validationService.otpLoginRegex.test(self.otpMail))) {
                  $rootScope.$broadcast("addAlert", {
                    text: "OTP_ERROR",
                  });
                  self.restCalled = false;
                  return;
                }

                if (!!!self.otpMail || (!!self.otpMail && !validationService.otpLoginRegex.test(self.otpMail))) {
                  $rootScope.$broadcast("addAlert", {
                    text: "OTP_ERROR",
                  });
                  self.restCalled = false;
                  return;
                }
                $userService
                  .checkOtp(
                    self.otp,
                    channel,
                    self.transactionOtp,
                    self.otpMail,
                    self.transactionOtpMail
                  )
                  .then(function (response) {
                    console.log("Response: ", response);
                    if (response.success && $configService.userIsRegistering()) {
                      $userService
                        .restorePassword(self.appPasswordUser)
                        .then(function (resp) {
                          if (resp.success) {
                            $rootScope.$broadcast("addAlert", {
                              text: "CHANGEPASS_005",
                            });
                            self.restCalled = false;

                            $rootScope.isMenuDisabled = false;
                            $scope.clickCloseRecoveryPassword();
                            location.reload();
                          } else {
                            $rootScope.$broadcast('cancel-timer');
                          }
                          self.restCalled = false;
                        })
                        .catch(function (error) {
                          $rootScope.$broadcast('cancel-timer');
                          console.log("error");
                          self.restCalled = false;
                        });
                    } else {
                      self.restCalled = false;
                      $rootScope.$broadcast('cancel-timer');
                    }

                  })
                  .catch(function (err) {
                    $rootScope.$broadcast('cancel-timer');
                    self.restCalled = false;
                    console.log("Error: ", err);
                  });

              }

            } else {
              if ($configService.userIsRegistering()) {
                $userService
                  .restorePassword(self.appPasswordUser)
                  .then(function (resp) {
                    if (resp.success) {
                      $rootScope.$broadcast("addAlert", {
                        text: "CHANGEPASS_005",
                      });
                      self.restCalled = false;
                      $rootScope.isMenuDisabled = false;
                      $scope.clickCloseRecoveryPassword();
                      location.reload();
                    } else {
                      $rootScope.$broadcast('cancel-timer');
                    }
                    self.restCalled = false;
                  })
                  .catch(function (error) {
                    $rootScope.$broadcast('cancel-timer');
                    self.restCalled = false;
                  });
              }
            }
          } else if (
            $configService.getUserStatus() == propMap["USER_STATUS_ENABLED"] ||
            $configService.getUserStatus() == propMap['USER_PASSWORD_EXPIRED']
          ) {
            $userService
              .updatePassword(self.appPasswordUser)
              .then(function (response) {
                if (response.success) {
                  $rootScope.$broadcast("addAlert", {
                    text: "CHANGEPASS_005",
                  });

                  response && $configService.updateUser(response.appUser);

                  /** initialize fields **/
                  self.appPasswordUser = {};
                  self.appPasswordUser.recovery = null;
                  self.appPasswordUser.password = null;
                  self.appPasswordUser.confirmedPassword = null;

                  /** valid the form **/
                  setFormIsValid($scope);
                  $rootScope.isMenuDisabled = false;
                  $scope.clickCloseRecoveryPassword();
                  location.reload();
                } else {
                  $rootScope.$broadcast('cancel-timer');
                }
                self.restCalled = false;
              })
              .catch(function (error) {
                $rootScope.$broadcast('cancel-timer');
                console.log("error");
                self.restCalled = false;
              });
          } else if (
            $configService.getUserStatus() == propMap["USER_STATUS_NEW_USER_R"]
          ) {
            var channel = $portalService
              .resolveContextApplicationName(context)
              .split("_")[1];
            self.appPasswordUser.identifier = $configService.getUser().identifier;
            if ($portalService.isArf()) {
              $userService
                .insertAppPassword(self.appPasswordUser)
                .then(function (response) {
                  if (response.success) {
                    $rootScope.$broadcast("addAlert", {
                      text: "CHANGEPASS_005",
                    });

                    $rootScope.isMenuDisabled = false;
                    $scope.clickCloseRecoveryPassword();
                    location.reload();
                  } else {
                    $rootScope.$broadcast('cancel-timer');
                  }
                  self.restCalled = false;
                })
                .catch(function (err) {
                  $rootScope.$broadcast('cancel-timer');
                  console.log("Error: ", err);
                  self.restCalled = false;
                });
            } else {
              $uniService
                .verificaCertificatoNumTel(self.otp, channel, self.transactionOtp)
                .then(function (response) {
                  console.log("Response: ", response);
                  if (response.success) {
                    $userService
                      .insertAppPassword(self.appPasswordUser)
                      .then(function (response) {
                        if (response.success) {
                          $rootScope.$broadcast("addAlert", {
                            text: "CHANGEPASS_005",
                          });

                          $rootScope.isMenuDisabled = false;
                          $scope.clickCloseRecoveryPassword();
                          location.reload();
                        } else {
                          $rootScope.$broadcast('cancel-timer');
                        }
                        self.restCalled = false;
                      })
                      .catch(function (error) {
                        $rootScope.$broadcast('cancel-timer');
                        console.log("error");
                        self.restCalled = false;
                      });
                  }
                })
                .catch(function (err) {
                  $rootScope.$broadcast('cancel-timer');
                  console.log("Error: ", err);
                  self.restCalled = false;
                });
            }
          }
        } else {
          $rootScope.$broadcast("addAlert", {
            text: "CHANGEPASS_008",
          });
          return;
        }
      };

      self.checkOldAndNewPassword = function () {
        if (self.appPasswordUser.password == self.appPasswordUser.recovery) {
          self.controlNew = true;
        } else self.controlNew = false;
      };

      self.checkNewAndConfirmedPassword = function () {
        if (
          self.appPasswordUser.password !=
          self.appPasswordUser.confirmedPassword
        ) {
          self.controlConfirm = true;
        }
        self.controlConfirm = false;
      };

      function setFormIsValid(scope) {
        scope.FormChangePassword.inputConfirmRecovery.$valid = true;
        scope.FormChangePassword.inputNewRecovery.$valid = true;
        scope.FormChangePassword.inputOldRecovery.$valid = true;

        scope.FormChangePassword.inputConfirmRecovery.$touched = false;
        scope.FormChangePassword.inputNewRecovery.$touched = false;
        scope.FormChangePassword.inputOldRecovery.$touched = false;
        console.log(scope);
      }

      self.initializeUser = function () { };

      self.$onInit = function () {
        self.appPasswordUser = {};
        $timeout(function () {
          $scope.startScrollBar();
        }, 0);

        self.user = $configService.getUser();
        if (!self.user.cf) {
          self.user.cf = self.user.identifier;
        }
        if ($configService.userIsRegistering()) {
          console.log("!isConv");
          self.disableClose = true;
        } else {
          self.disableClose = false;
        }
        self.otp = null;

        self.vendorNaRegistering = $configService.userIsVendorNaRegistering();
        self.isUserEnabled = $configService.isUserEnabled();
        self.isUserExpiredPassword = $configService.isUserExpiredPassword();

        self.getDealerUser();
        if (self.mode !== "NUARC") {
          self.getModalitaInvio();
        }

        if (self.mode === "NUARC" && $configService.getUser().type != "") {
          self.activitiesList = [];
          self.appUserList = [{}];
          self.fatturazione = Fatturazione.build();
          $scope.appUser.metadataAppUserPojo.fatturazioneElettronica =
            self.fatturazione;
          $scope.user = $configService.getUser();
          $scope.controlPrivacy.cf = $configService.getUser().identifier;
          $scope.controlPrivacy.piva = $configService.getUser().piva;
          self.totalPages = 0;
          self.pageIndex = 1;
          self.limit = 5;
          self.offset = 0;
          if (!self.firstAccess) {
            self.getFattData();
          }
        }
        self.checkForLastActivityAccordion = false;
        self.checkForPrivacy = false;
        self.checkForUpdateUserData = false;
        self.checkForDealeruser = false;
      };

      /**
       * Validation Logic
       */

      //changing password
      self.isValidationOkChanging = function () {
        if (
          !self.appPasswordUser ||
          !self.appPasswordUser.password ||
          !self.appPasswordUser.confirmedPassword ||
          !self.appPasswordUser.inputOldRecovery ||
          !self.validationService.isValidPassword(
            self.appPasswordUser.password
          ) ||
          !self.validationService.isValidPassword(
            self.appPasswordUser.confirmedPassword
          ) ||
          !self.validationService.isValidPassword(
            self.appPasswordUser.inputOldRecovery
          )
        ) {
          return false;
        }
        return true;
      };

      self.isValidationOk = function () {
        if (self.status === propMap["USER_STATUS_NEW_USER_R"]) {
          if (
            !self.appPasswordUser ||
            !self.appPasswordUser.password ||
            !self.appPasswordUser.confirmedPassword ||
            !self.validationService.isValidPassword(
              self.appPasswordUser.password
            ) ||
            !self.validationService.isValidPassword(
              self.appPasswordUser.confirmedPassword
            )
          ) {
            return false;
          }
          return true;
        } else {
          if (
            !self.appPasswordUser ||
            !self.appPasswordUser.password ||
            !self.appPasswordUser.confirmedPassword ||
            !self.appPasswordUser.recovery ||
            !self.validationService.isValidPassword(
              self.appPasswordUser.password
            ) ||
            !self.validationService.isValidPassword(
              self.appPasswordUser.confirmedPassword
            ) ||
            !self.validationService.isValidPassword(
              self.appPasswordUser.recovery
            )
          ) {
            return false;
          }
          return true;
        }
      };
      //changing password
      self.isRequiredOkChanging = function () {
        if (
          !self.appPasswordUser ||
          !self.appPasswordUser.password ||
          !self.appPasswordUser.confirmedPassword ||
          !self.appPasswordUser.inputOldRecovery
        ) {
          return false;
        }
        return true;
      };

      self.isRequiredOk = function () {
        if (self.status === propMap["USER_STATUS_NEW_USER_R"]) {
          if (
            !self.appPasswordUser ||
            !self.appPasswordUser.password ||
            !self.appPasswordUser.confirmedPassword
          ) {
            return false;
          }
          return true;
        } else {
          if (
            !self.appPasswordUser ||
            !self.appPasswordUser.password ||
            !self.appPasswordUser.confirmedPassword ||
            !self.appPasswordUser.recovery
          ) {
            return false;
          }
          return true;
        }
      };

      $scope.startScrollBar = function (property) {
        if (
          !$("#collapseFour.mCustomScrollbar").length ||
          !$("#collapseTwo.mCustomScrollbar").length
        ) {
          scrollBar(true);
        }

        if (property == "latestActivities") {
          self.checkForLastActivityAccordion = !self.checkForLastActivityAccordion;

          if (self.checkForLastActivityAccordion) {
            self.getLog();
          }


        }

        if (property == "pri") {
          self.checkForPrivacy = !self.checkForPrivacy;
          if (self.checkForPrivacy) {
            $scope.getPrivacyEnrollment();
          }

        }

        $scope.$broadcast("collapseFatt");
      };

      /* ANAGRAFICA E RECAPITI */

      self.saveInfo = function (data) {
        $scope.fr.user.tel = data;

        $userService.updateAppUser($scope.fr.user).then(function (response) {
          if (response.success) {
            $scope.editBool.tel = false;
          }
        });
      };

      /* GUIDA AI SERVIZI */
      //$configService.getUser()
      self.generateDownloadLink = function (nameFile) {

        var url = "/uni/download/service-infos/" +
          encodeURIComponent(nameFile) + "/"

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      self.updateEmail = function (mode) {
        switch (mode) {
          case "NUARC":
            if (validationService.isValidEmail($scope.appUser.email)) {
              self.updateProfileUser("email");
            } else {
              $rootScope.$broadcast("addAlert", {
                text: "VAL_WRONG_EMAIL",
              });
            }
            break;
          default:
            if (validationService.isValidEmail($scope.fr.user.email)) {
              $scope.editBool.email = false;
              $userService
                .updateEmail($scope.fr.user.email)
                .then(function (response) {
                  console.log("email updated! ", response);
                  self.updateUserData();
                });
            } else {
              $rootScope.$broadcast("addAlert", {
                text: "VAL_WRONG_EMAIL",
              });
            }
        }
      };

      $scope.updateDatiFatturazione = function () {
        $arcService
          .setFattData($scope.appUser.metadataAppUserPojo.fatturazioneElettronica)
          .then(function (response) {
            if (response) {
              console.log("OK!", response);
            }
          })
          .catch(function (error) {
            console.log("ERROR:", error);
          });
      };

      self.updateProfileUser = function (typeOfField) {
        $arcService
          .updateProfileUser($scope.appUser)
          .then(function (response) {
            console.log("field updated! ", response);
            switch (typeOfField) {
              case "name":
                $scope.editBool.refPersonName = false;
                break;
              case "contactType":
                $scope.editBool.refPersonType = false;
                break;
              case "email":
                $scope.editBool.refPersonEmail = false;
                if (response.success) {
                  $rootScope.$broadcast("addAlert", {
                    text: "UPDATE_EMAIL_ARC_OK",
                  });
                }
                break;
              case "tel":
                $scope.editBool.refPersonTel = false;
                break;
              default:
                return;
            }
            self.updateUserData();
          })
          .catch(function (error) {
            console.log("ERROR:", error);
          })
          .finally(function () {
            console.log("ANDATA!");
          });
      };

      self.updateTel = function (field, mode) {
        switch (mode) {
          case "NUARC":
            if (validationService.isValidTel(field)) {
              self.updateProfileUser("tel");
            } else {
              $rootScope.$broadcast("addAlert", {
                text: "VAL_WRONG_TELEPHONE",
              });
            }

            break;
          default:
            if (validationService.isValidTel(field)) {
              $scope.editBool.tel = false;
              $userService
                .updateTelephone(field)
                .then(function (response) {
                  console.log("tel updated! ", response);
                  self.updateUserData();
                });
            } else {
              $rootScope.$broadcast("addAlert", {
                text: "VAL_WRONG_TELEPHONE",
              });
            }
        }
      };

      self.updateUserData = function () {
        $scope.$broadcast("collapseFatt");
        $userService.getAppUser().then(function (user) {
          console.log("user's data refreshed!", user);
          $scope.appUser.metadataAppUserPojo.personaRiferimentoPrincipale = user.metadataAppUserPojo ? user.metadataAppUserPojo.personaRiferimentoPrincipale : null;
          $scope.appUser.metadataAppUserPojo.tipologiaContatto = user.metadataAppUserPojo ? user.metadataAppUserPojo.tipologiaContatto : null;
          $scope.appUser.metadataAppUserPojo.cf = user.identifier;
          $scope.appUser.email = user.email;
          $scope.appUser.tel = user.tel;
        });
      };

      self.getDealerUser = function () {
        $userService.getDealerUser().then(function (dealer) {
          if (dealer) {
            self.dealerUser = dealer;
          }
        });
        $scope.$broadcast("collapseFatt");
      };

      self.sendOtp = function () {
        self.restSendOTPcall = true;
        var channel = $portalService
          .resolveContextApplicationName(context)
          .split("_")[1];
        $uniService
          .certificaNumeroTelefono(self.dealerUser.tel, channel)
          .then(function (response) {
            if (!response.success) {
              console.log("ERROR in CertificaNumeroTelefono");
              $rootScope.$broadcast("addAlert", {
                text: "ERROR_SENDING_OTP",
              });
            } else {
              console.log("SUCCESS in CertificaNumeroTelefono");
              self.transactionOtp =
                response.startMobileNumberCertification.context.transactionId;
              console.log("otpTransactionId" + self.transactionOtp);
              $rootScope.$broadcast("addAlert", {
                text: "OTP_SENT",
              });
              $rootScope.$broadcast('cancel-timer');
            }
            self.restSendOTPcall = false;
          })
          .catch(function (err) {
            $rootScope.$broadcast('cancel-timer');
            self.restSendOTPcall = false;
            console.log("Error: ", err);
          });
      };

      self.toggleLock = function () {
        self.locked = !self.locked;
      };

      self.getModalitaInvio = function () {
        self.loadingSelectModalita = true;
        $typeDomainService
          .getDomainSet("PROFILO_ARC", "PREFERENZA_CONSEGNA")
          .then(function (response) {
            self.modalitaDiInvio = response.domainList;
          })
          .catch(function (error) {
            console.log("Error", error);
          })
          .finally(function () {
            self.loadingSelectModalita = false;
          });
      };

      self.getLog = function () {
        self.isPending = true;
        self.filter = {
          offset: self.offset,
          limit: self.limit,
        };
        $arcService
          .getLatestActivities(self.filter)
          .then(function (response) {
            self.activitiesList = response;
            self.totalPages = Math.ceil(response.length / 5);
          })
          .catch(function (error) {
            console.log("ERROR:", error);
            self.isPending = false;
          })
          .finally(function () {
            console.log("Andata!");
            self.isPending = false;
          });
      };

      $scope.fattElettronica = function (value, result) {
        if (result === true) {
          $scope.appUser.metadataAppUserPojo.fatturazioneElettronica = value;
          console.log("Fatturazione: ", self.model);
          $scope.enableConfirm = true;
        } else {
          $scope.enableConfirm = false;
        }
      };

      $scope.getPrivacyEnrollment = function () {
        self.loadingPrivacy = true;
        $privacyService
          .getPrivacyDataProfilo()
          .then(function (response) {
            $scope.privacy = response.privacy;
            $scope.listaConsensi = response.privacy.listaConsensi;
            self.loadingPrivacy = false;

          })
          .catch(function (error) {
            console.log("ERROR:", error);
            self.loadingPrivacy = false;
          });

      };

      $scope.nuGenerateLinkForPrivacy = function () {

        var url = '/uni/download/service-infos/' +
          encodeURIComponent($scope.privacy.docDownloadCode) + '/'

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      }

      $scope.generateLinkForPrivacy = function (formaGiuridica) {
        var filename = '';
        if ($giuridicVersion.isDittaIndividuale(formaGiuridica)) {
          filename = 'PRIVACY_DIN'

        } else {
          filename = 'PRIVACY'
        }

        var url = '/uni/download/service-infos/' +
          encodeURIComponent(filename) + '/'

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      $scope.setNewPrivacyData = function () {
        $privacyService
          .setPrivacyDataProfilo($scope.privacy)
          .then(function (response) {
            if (response.success === true) {
              console.log("OK!");
              $rootScope.$broadcast("addAlert", {
                text: "PRIVACY_PREF_SUBMITTED"
              })
            }
          })
          .catch(function (error) {
            console.log("ERROR:", error);
          });
      };

      $scope.downloadPrivacy = function () {
        $scope.documentPrivacyDownloaded = true;
      };

      self.getFattData = function () {
        self.restFatturazioneFinish = false;
        $arcService
          .getFattData()
          .then(function (response) {
            if (response.fatturazioneElettronica && response.fatturazioneElettronica.cdDestinatarioFatturazione) {
              $scope.appUser.metadataAppUserPojo.fatturazioneElettronica.cdDestinatarioFatturazione =
                response.fatturazioneElettronica.cdDestinatarioFatturazione;
            }
            if (response.fatturazioneElettronica && response.fatturazioneElettronica.emailFatturazioneElettronica) {
              $scope.appUser.metadataAppUserPojo.fatturazioneElettronica.emailFatturazioneElettronica =
                response.fatturazioneElettronica.emailFatturazioneElettronica;
            }
            if (response.fatturazioneElettronica && response.fatturazioneElettronica.riferimentoAmministrativo) {
              $scope.appUser.metadataAppUserPojo.fatturazioneElettronica.riferimentoAmministrativo =
                response.fatturazioneElettronica.riferimentoAmministrativo;
            }
            if (response.fatturazioneElettronica && response.fatturazioneElettronica.editable) {
              $scope.fatturazioneEditable = true;
            }
            self.restFatturazioneFinish = true;
          })
          .catch(function (error) {
            console.log("ERROR:", error);
            self.restFatturazioneFinish = true;
          });
      };

      self.pageSIndexIndietro = function (value) {
        if (value == "init") {
          self.pageIndex = 1;
        } else {
          if (self.pageIndex > 1) {
            self.pageIndex--;
          }
        }
        updateOffsetAndSearch();
      };

      self.pageSIndexAvanti = function (value) {
        if (value == "end") {
          //subito pagina finale
          self.filter.pageIndex = self.filter.totalPages;
        } else {
          //avanzo +1
          if (self.pageIndex < self.totalPages) {
            self.pageIndex++;
          }
        }
        updateOffsetAndSearch();
      };

      function updateOffsetAndSearch() {
        self.offset = (self.pageIndex - 1) * self.limit;
        self.getLog();
      }

      self.handlePrivacyMods = function (value) {
        if (value) {
          self.enableConfirmPrivacyButton = true;
        }
      };

      self.updateDealerEmail = function () {
        if (validationService.isValidEmail(self.dealerUser.email)) {
          $scope.editBool.dealerUserEmail = false;
          $userService
            .updateDealerUserEmail(self.dealerUser.email)
            .then(function (response) {
              if (response) {
                self.getDealerUser();
              }
            })
            .catch(function (error) {
              console.log("ERROR: ", error);
            });
        } else {
          $rootScope.$broadcast("addAlert", {
            text: "VAL_WRONG_EMAIL",
          });
        }
      };

      $scope.updateDatiFatturazione = function () {

      }

      self.startUpdateUserData = function (id) {
        self.collapseOtherAccordion(id);
        self.checkForUpdateUserData = !self.checkForUpdateUserData;
        if (self.checkForUpdateUserData) {
          self.updateUserData();
        }
      }

      self.startDealerUser = function (id) {
        self.collapseOtherAccordion(id);
        self.checkForDealeruser = !self.checkForDealeruser;
        if (self.checkForDealeruser) {
          self.getDealerUser();
        }
      }

      self.checkObblQuest = function () {
        var test = true;

        test = $scope.listaConsensi.filter(function (element) {
          return element.obbligatorio == true
        }).every(function (esito) {
          return esito.esito == true
        })


        return !test;
      }

      self.collapseOtherAccordion = function (id) {
        var allAccordion = ["#collapseZero", "#collapseOne", "#collapseTwo", "#collapseThree", "#collapseFive", "#collapseSix", "#collapseSeven", "#collapseEight", "#fattElectr"];

        var accordionToClose = allAccordion.filter(x => {
          return x != id
        })

        accordionToClose.forEach(iesimo => {
          jQuery(iesimo).collapse("hide");
        })
      }

      self.callChangeRespUtenza = function () {
        var subtype = '006';
        var type = '01';

        if (!!self.restChangeRespUtenzaCalling) {
          subtype = '999';
          type = '99';
        }

        self.restChangeRespUtenzaCalling = true;

        $arcService.startRequestPv(
          type,
          subtype,
        )
          .then(function (response) {
            if (response.idWf && 'REQUEST_PV_SUBMITTED' !== response.keyMessage) {
              if (response.status) {
                  $rootScope.$broadcast('addAlert', { text: 'RESP_USER_REQUEST_PRESENT', dynamicInput: [response.idWf, response.status] });
                  $scope.enableMenu();
                  $scope.clickCloseRecoveryPassword();
              } else {
                $RichiestePostVenditaService.resumeInstance(response.idWf, 'WF_POSTVENDITA', 'NUOVO_RESP_UTENZA')
                  .then(function (responseResumeInstance) {
                    responseResumeInstance.fromResume = true;
                    $transactionFactory.set(responseResumeInstance);
                    $scope.enableMenu();
                    $scope.clickCloseRecoveryPassword();
                    $location.path(responseResumeInstance.route);
                  })
                  .catch(function (error) {
                    console.log(error);
                  })
                  .finally(function () {
                    if (subtype === '006' && type === '01') {
                      self.restChangeRespUtenzaCalling = false;
                    }
                  })
              }
            } else {
              var richiestePostVenditaModel = RichiestePostVendita.build({
                id: response.idRichiesta,
                idWf: response.idRichiesta,
                applicationName: response.applicationName,
                typeWf: response.type,
                route: response.targetWizard,
                viewIndex: response.index,
                type: type,
                subtype: subtype,
              });
              $transactionFactory.set(richiestePostVenditaModel);
              $scope.enableMenu();
              $scope.clickCloseRecoveryPassword();
              $location.path(response.targetWizard);
              if (subtype === '006' && type === '01') {
                self.restChangeRespUtenzaCalling = false;
              }
            }
          })
          .catch(function (error) {
            console.log(error);
            self.restChangeRespUtenzaCalling = false;
          })
      }

      self.sendOtpMail = function () {
        self.restSendOTPMailcall = true;

        $userService.sendOtpPec()
          .then(function (response) {
            if (response.success) {
              if(response.previousOtp) {
                self.transactionOtpMail = response.otpPecTransactionId;
                $rootScope.$broadcast("addAlert", {
                  text: "OTP_PREVIOUS",
                });

              } else {
                self.transactionOtpMail = response.otpPecTransactionId;
                $rootScope.$broadcast("addAlert", {
                  text: "OTP_SENT",
                });
              }
            } else {
              $rootScope.$broadcast("addAlert", {
                text: "ERROR_SENDING_OTP",
              });
              $rootScope.$broadcast('cancel-timer');
            }
            self.restSendOTPMailcall = false;
          })
          .catch(function (error) {
            $rootScope.$broadcast('cancel-timer');
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_SENDING_OTP",
            });
            console.log(error);
            self.restSendOTPMailcall = false;
          })


      }

      self.chekOtpCell = function () {
        self.loaderCertifica = true;
        var channel = $portalService
          .resolveContextApplicationName(context)
          .split("_")[1];
        $uniService
          .verificaCertificatoNumTel(self.otp, channel, self.transactionOtp)
          .then(function (response) {
            console.log("Response: ", response);
            if (response.success) {
              // se è ok chiudo la popup e faccio certificare mail e cambio password
              $modalService.closeModal('certificaCell-modal');
              self.loaderCertifica = false;
            } else {
              self.loaderCertifica = false;
            }
          })
          .catch(function (err) {
            console.log("Error: ", err);
            self.loaderCertifica = false;
          });

      }

    }
  });